<div class="tw-rounded-full tw-w-[8px] tw-h-[8px] wo-dot-status--{{type}}"></div>
